import { render, staticRenderFns } from "./programmingSubject.vue?vue&type=template&id=10b8d1fc&scoped=true"
import script from "./programmingSubject.vue?vue&type=script&lang=js"
export * from "./programmingSubject.vue?vue&type=script&lang=js"
import style1 from "./programmingSubject.vue?vue&type=style&index=1&id=10b8d1fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b8d1fc",
  null
  
)

export default component.exports